import { Box } from '@wix/design-system';
import { CoreDomainSearchStore, DomainSearchSuiteModule } from '@wix/domains-search-suite';
import React, { useEffect } from 'react';
import { ResultsHeader } from '../../Components/Headers/ResultsHeader/ResultsHeader';
import { AccountVoucherBanner } from '../../Components/VoucherBanner/AccountVoucherBanner';
import { Recommendations, RecommendationsError } from '../../Components/Recommendations';
import { ViewMode } from '../../types';
import { useDomainSearchGateBi } from '../../hooks/useDomainSearchGateBi';
import { useIsMobile } from '../../hooks/useIsMobile';
import { useIsMailboxReferralBM } from '../../hooks/useIsMailboxReferral';
import { useQuerySubmit } from '../../hooks/useQuerySubmit';
import { useRecommendations } from '../../hooks/useRecommendations';
import { useResultsBack } from '../../hooks/useResultsBack';
import { useResultsPageOfferingsBi } from '../../hooks/useResultsPageOfferingsBi';
import { useGatePageBackground } from '../../hooks/useGatePageBackground';
import { useIsBmHarmonyThemeEnabled } from '../../utils/harmonyTheme';
import { HarmonyThemeProvider } from '@wix/core-domain-search';
import s from '../resultsPage.scss';
import transition from '../viewTransitions.css';
import { clsx } from 'clsx';
import { accountLevelStatusesOverrides } from './accountLevelStatusesOverrides';
export const AccountLevelResultsPage = _ref => {
  let {
    handlers
  } = _ref;
  const isHarmonyTheme = useIsBmHarmonyThemeEnabled();
  return /*#__PURE__*/React.createElement(DomainSearchSuiteModule.Provider, {
    translations: {
      Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
    },
    actions: {
      siteInfo: {
        externalViewer: false
      },
      handlers,
      statusesOverrides: accountLevelStatusesOverrides
    }
  }, /*#__PURE__*/React.createElement(HarmonyThemeProvider, {
    enabled: isHarmonyTheme
  }, /*#__PURE__*/React.createElement(AccountLevelResultsPageContent, null)));
};
const AccountLevelResultsPageContent = () => {
  const isMobile = useIsMobile();
  const handleBackClick = useResultsBack();
  const isMailboxReferral = useIsMailboxReferralBM();
  const pageBackground = useGatePageBackground();
  useDomainSearchGateBi({
    viewMode: ViewMode.ACCOUNT_LEVEL_RESULTS_PAGE
  });
  const {
    recommendations,
    isLoading,
    query,
    hasNextPage: hasMore,
    fetchNextPage,
    isFetchingNextPage,
    error,
    biError,
    onRetry,
    isPricingLoading
  } = useRecommendations();
  const {
    updateUrl
  } = DomainSearchSuiteModule.SDK.hooks.useUrlRecovery();
  useQuerySubmit({});
  useResultsPageOfferingsBi({
    recommendations,
    isLoading,
    biError
  });
  useEffect(() => {
    return () => {
      CoreDomainSearchStore.resetStore();
    };
  }, []);
  const emptyQueryStatus = !isLoading && recommendations.length > 0 && !query;
  const searchBar = /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.DomainSearchBar, {
    compact: true,
    showOptionsIfEmptyInput: false,
    autoFocus: false,
    useModalToolbar: isMobile,
    onSubmit: filters => {
      updateUrl(filters);
    },
    onFiltersChange: (key, value) => {
      if (key === 'tlds') {
        DomainSearchSuiteModule.internals.bi.onSelectTld == null || DomainSearchSuiteModule.internals.bi.onSelectTld({
          tld: JSON.stringify(value)
        });
      } else {
        DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
          ctaClick: key,
          value: JSON.stringify(value)
        });
      }
    },
    Layouts: {
      StatusComponent: () => emptyQueryStatus ? /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.EmptyQueryStatus, null) : /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.Status, null)
    }
  });
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    display: "grid",
    className: clsx(s.resultsPage, s.noInsights),
    gap: "SP6 0",
    height: "100%",
    backgroundColor: pageBackground,
    overflow: "auto"
  }, /*#__PURE__*/React.createElement(Box, {
    boxSizing: "border-box",
    align: "center",
    gridArea: "header",
    top: isMobile ? undefined : '0',
    position: isMobile ? undefined : 'sticky',
    width: "100%",
    zIndex: 10,
    padding: "SP5 48px",
    backgroundColor: pageBackground,
    direction: "vertical",
    gap: "SP6"
  }, /*#__PURE__*/React.createElement(AccountVoucherBanner, null), /*#__PURE__*/React.createElement(ResultsHeader, {
    className: transition.header,
    onBackClick: handleBackClick,
    isMailboxReferral: isMailboxReferral
  }), !isMobile && /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      zIndex: 11
    },
    className: transition.searchBar
  }, searchBar)), isMobile && /*#__PURE__*/React.createElement(Box, {
    gridArea: "searchbar",
    boxSizing: "border-box",
    position: "sticky",
    top: "0",
    zIndex: 11,
    backgroundColor: pageBackground,
    direction: "vertical",
    padding: "0 SP5",
    width: "100%"
  }, /*#__PURE__*/React.createElement("div", {
    className: transition.searchBar
  }, searchBar)), error ? /*#__PURE__*/React.createElement(RecommendationsError, {
    error: error,
    onRetry: onRetry,
    gridColumn: "1 / -1"
  }) : /*#__PURE__*/React.createElement(Recommendations, {
    recommendations: recommendations,
    isLoading: isLoading,
    hasMore: hasMore,
    isPricingLoading: isPricingLoading,
    fetchNextPage: () => {
      DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
        ctaClick: 'show_more_results'
      });
      fetchNextPage();
    },
    isFetchingNextPage: isFetchingNextPage,
    gridArea: "content"
  }));
};
//# sourceMappingURL=AccountLevelResultsPage.js.map